import { handleActions, Reducer } from "redux-actions";
import {  
   ACTION_DELETECUSTOMER_SUCCESS,
   ACTION_GETCUSTOMERLIST_SUCCESS,
   ACTION_GETCUSTOMERDETAIL_SUCCESS,
   ACTION_GETSTATISTICS_SUCCESS,
   ACTION_UPDATECUSTOMER_SUCCESS,
   ACTION_GETREPORTCONTRAST_SUCCESS
} from "../actions/customer";

export interface customerState {
    customerList: any[],
    customerDetail: any
    statistics: any
    reportContrast: any
}

const defaultState: customerState = {
   customerList: [],
   customerDetail: {},
   statistics: {},
   reportContrast: {}
}

function handleActionGetCustomerListSuccess(state: customerState, action: any): customerState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        customerList: action.payload.data,
    };
}

function handleActionGetCustomerDetailSuccess(state: customerState, action: any): customerState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        customerDetail: action.payload.data,
    };
}

function handleActionUpdateCustomerSuccess(state: customerState, action: any): customerState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    };
}

function handleActionDeleteCustomerSuccess(state: customerState, action: any): customerState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    };
}

function handleActionGetStatiticsSuccess(state: customerState, action: any): customerState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        statistics: action.payload.data
    };
}

function handleActionGetReportContrastSuccess(state: customerState, action: any): customerState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        reportContrast: action.payload.data
    };
}

export const customerReducer: Reducer<customerState, any> = handleActions(
    {
       [ACTION_GETCUSTOMERLIST_SUCCESS]: handleActionGetCustomerListSuccess,
       [ACTION_GETCUSTOMERDETAIL_SUCCESS]: handleActionGetCustomerDetailSuccess,
       [ACTION_GETSTATISTICS_SUCCESS]: handleActionGetStatiticsSuccess,
       [ACTION_UPDATECUSTOMER_SUCCESS]: handleActionUpdateCustomerSuccess,
       [ACTION_DELETECUSTOMER_SUCCESS]: handleActionDeleteCustomerSuccess,
       [ACTION_GETREPORTCONTRAST_SUCCESS]: handleActionGetReportContrastSuccess
    },
    defaultState
);
